import { ChangeEvent, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
// Components

// actions
import * as worldMapTeamAction from "../../actions/teamMap/WorldMapTeamAction";

import DynatraceContactDTO from "../../models/teamMap/DynatraceContactDTO";
import { Button, Table } from "react-bootstrap";
import {SectionEditModal} from "../../components/SectionEditModal";
import WorldMapTeam from "./WorldMapTeam";


function WorldMapTeamEdit() {

  let history = useHistory();
  const region = useParams()["region"].toUpperCase();
  const [dynatraceContactDTO, setDynatraceContactDTO] = useState<Array<DynatraceContactDTO>>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<Array<DynatraceContactDTO>>([]);
  const [sections, setSections] = useState<Array<string>>([]);
  const [selectedSection, setSelectedSection] = useState<string>('');
  const [isSectionModalOpen, setIsSectionModalOpen] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  

  useEffect(() => {
    canYouHaveAccess();
    console.log(region);
    getDynatraceContactsByRegion();
  }, []);


  const handleInputChange = (e: ChangeEvent<HTMLInputElement| HTMLSelectElement>, id: number) => {
    const { name, value } = e.target;
    const updatedFormData = formData.map(item => 
      item.id === id ? { ...item, [name]: value } : item
    );
    setFormData(updatedFormData);
  };

  const handleEdit = (index) => {
    setIsEditing(true);
    setError(null);
  };

  const handleSave = () => {
    setIsLoading(true);
    const isValid = formData.every(item => 
      item.section === "no section" || (item.name && item.email && item.title && item.position)
    );

    if (!isValid) {
      setError('All fields are mandatory. Please fill in all fields.');
      return;
    }
    setDynatraceContactDTO(formData);
    setIsEditing(false);
    setError(null);
    worldMapTeamAction
      .saveUpdateContacts(formData)
      .then(c => {
        setDynatraceContactDTO(c.data);
        setFormData(c.data);
      })
      .then(c => {
        setIsLoading(false);
      })
      .catch(err => {
        console.error('oops, something went wrong!', err);
        setError("There is an error. Make sure your vpn is on. or try later.");
        setFormData(dynatraceContactDTO);
      });

  };

  const handleCancel = () => {
    setFormData(dynatraceContactDTO);
    setIsEditing(false);
    setError(null);
  };

  const handleSectionChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedSection(e.target.value);
  };

  const handleAddRecord = () => {
    //const newId = (dynatraceContactDTO!.length + 1); // Generate a new ID
    const newRecord: DynatraceContactDTO = {
      id: undefined,
      name: '',
      email: '',
      phoneNumber: '',
      region: region,
      color: '#1C1C1C',
      section: selectedSection,
      title: "",
      description: "",
      position: undefined
    };
    setFormData([...formData, newRecord]);
    setIsEditing(true);
  };

  const handleSaveSections = (updatedSections: string[]) => {
    const updatedData = dynatraceContactDTO.map(item => {
      const updatedSectionIndex = sections.findIndex(section => section === item.section);
      if (updatedSectionIndex > -1) {
        return { ...item, section: updatedSections[updatedSectionIndex] };
      }
      return item;
    });
    
    setSections(updatedSections);
    setDynatraceContactDTO(updatedData);
    setFormData(updatedData);
    setIsSectionModalOpen(false);
  };


  return (
    <>
    {isLoading ? <div className="m-4" style={{ color: 'red' }}>{"is Loading..."}</div> :
    <div>
      <h1 className="m-3">Editable Table - {region}</h1> 
      <label className="ml-4">
        Filter by section:
        <select className="ml-2 mr-5" value={selectedSection} onChange={handleSectionChange}>
          {sections.map(section => (
            <option key={section} value={section}>
              {section}
            </option>
          ))}
        </select>
      </label>
      <Button onClick={isEditing ? handleSave : handleEdit} className="mt-3 mb-3">
        {isEditing ? 'Save' : 'Edit'}
      </Button>
      <Button className="ml-2" onClick={handleAddRecord}>Add New Record</Button>
      {isEditing && <Button className="btn-danger ml-2"  onClick={handleCancel}>Cancel</Button>}
      <Button className="ml-5 btn-secondary" disabled={isEditing}  onClick={() => setIsSectionModalOpen(true)}>Edit Sections</Button>
      <Button className="ml-5 btn-dark" href={'/world-map/edit/region/' + region}>Edit World</Button>
      <Button className="ml-2 btn-dark" href={'/world-map/' + region}>See Map</Button>
      {error && <div className="m-4" style={{ color: 'red' }}>{error}</div>}
      <Table className="mb-5">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Ttile</th>
            <th>Section</th>
            <th>Description</th>
            <th>Color</th>
            <th>position</th>
          </tr>
        </thead>
        <tbody>
          {formData?.filter(item => item.section === selectedSection).map((item) => (
            <tr key={item.id}>
            <td>
                { isEditing ? (
                  <input
                    type="text"
                    name="name"
                    value={formData.find(d => d.id === item.id)?.name || ''}
                    onChange={(e) => handleInputChange(e, item.id!)}
                    
                  />
                ) : (
                  item.name || ''
                )}
              </td>
            <td>
              { isEditing ? (
                <input
                  type="email"
                  name="email"
                  value={formData.find(d => d.id === item.id)?.email || ''}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                item.email || ''
              )}
            </td>
            <td>
              { isEditing ? (
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.find(d => d.id === item.id)?.phoneNumber}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                item.phoneNumber || ""
              )}
            </td>
            <td>
              { isEditing ? (
                <input
                  type="text"
                  name="title"
                  value={formData.find(d => d.id === item.id)?.title || ''}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                item.title || ''
              )}
            </td>
            <td>
                {isEditing ? (
                  <select
                    name="section"
                    value={formData.find(d => d.id === item.id)?.section || ''}
                    onChange={(e) => handleInputChange(e, item.id!)}
                  >
                    {sections.map(section => (
                      <option key={section} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                ) : (
                  item.section || ''
                )}
              </td>
            <td>
              { isEditing ? (
                <input
                  type="text"
                  name="description"
                  value={formData.find(d => d.id === item.id)?.description || ''}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                item.description || ''
              )}
            </td>
            <td>
              { isEditing ? (
                <input
                type="color"
                name="color"
                value={formData.find(d => d.id === item.id)?.color || '#1C1C1C'}
                  //value={formData[index].color || ''}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                <div style={{ backgroundColor: item.color || '#1C1C1C', width: '50px', height: '20px' }}>
                  </div>
              )}
            </td>
            <td>
              { isEditing ? (
                <input
                  type="text"
                  name="position"
                  value={formData.find(d => d.id === item.id)?.position || ''}
                  onChange={(e) => handleInputChange(e, item.id!)}
                />
              ) : (
                item.position || ''
              )}
            </td>
          </tr>
        ))}
 
        </tbody>
      </Table>
      {console.log(isSectionModalOpen)}
      {isSectionModalOpen && (
        <SectionEditModal
          sections={sections}
          onSave={handleSaveSections}
          onClose={() => setIsSectionModalOpen(false)}
        />
      )}
      <WorldMapTeam isSecondaryScreen={true}></WorldMapTeam>
    
    </div>
  }
    </>
  );

    function canYouHaveAccess() {
    try {
        if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
        }
    } catch (err) {
        

    }
    };

    async function getDynatraceContactsByRegion() {
      worldMapTeamAction.getDynatraceContactsByRegion(region).then(response => {
        const team: Array<DynatraceContactDTO> = response.data.sort((a, b) =>Number(a.position) - Number(b.position));
        setDynatraceContactDTO(team);
        setFormData(team);
        const sectionNames = Array.from(
          new Set(team.map(item => item.section).filter((section): section is string => section !== undefined && section!=="no section"))
        );
        setSections(sectionNames);
        setSelectedSection(sectionNames[0] || '');
      }).catch(err => {
        console.error('oops, something went wrong!', err);
      });
    }


}

export default WorldMapTeamEdit;

